var map = {
	"./image-cards.de-CH.json": 1490,
	"./image-cards.de-DE.json": 1491,
	"./image-cards.en-CA.json": 1492,
	"./image-cards.en-GB.json": 1493,
	"./image-cards.en-IN.json": 1494,
	"./image-cards.en-ME.json": 1495,
	"./image-cards.en-US.json": 1496,
	"./image-cards.es-EM.json": 1497,
	"./image-cards.es-ES.json": 1498,
	"./image-cards.fr-BE.json": 1499,
	"./image-cards.fr-CA.json": 1500,
	"./image-cards.fr-CH.json": 1501,
	"./image-cards.nl-BE.json": 1502,
	"./image-cards.nl-NL.json": 1503,
	"./image-cards.pl-PL.json": 1504,
	"./image-cards.pt-BR.json": 1505
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1489;